var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRepeat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.62995 6.05779H14.9633V7.54946C14.9633 7.92446 15.4133 8.10779 15.6716 7.84112L17.9966 5.51612C18.1633 5.34946 18.1633 5.09112 17.9966 4.92446L15.6716 2.59946C15.6129 2.54187 15.5384 2.50296 15.4576 2.48764C15.3767 2.47231 15.2932 2.48125 15.2174 2.51334C15.1417 2.54542 15.0771 2.5992 15.0319 2.66792C14.9867 2.73663 14.9628 2.81719 14.9633 2.89946V4.39112H5.79662C5.33829 4.39112 4.96329 4.76612 4.96329 5.22446V8.55779C4.96329 9.01612 5.33829 9.39112 5.79662 9.39112C6.25495 9.39112 6.62995 9.01612 6.62995 8.55779V6.05779ZM14.9633 14.3911H6.62995V12.8995C6.62995 12.5245 6.17995 12.3411 5.92162 12.6078L3.59662 14.9328C3.42995 15.0995 3.42995 15.3578 3.59662 15.5245L5.92162 17.8495C5.98036 17.907 6.05484 17.9459 6.13567 17.9613C6.21649 17.9766 6.30004 17.9677 6.37579 17.9356C6.45154 17.9035 6.5161 17.8497 6.56133 17.781C6.60656 17.7123 6.63043 17.6317 6.62995 17.5495V16.0578H15.7966C16.2549 16.0578 16.6299 15.6828 16.6299 15.2245V11.8911C16.6299 11.4328 16.2549 11.0578 15.7966 11.0578C15.3383 11.0578 14.9633 11.4328 14.9633 11.8911V14.3911Z",
    fill: "#8996B8",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_2448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5 9.50446L11 7.50446V13.0045",
    stroke: "#8996B8",
    strokeOpacity: 0.6,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    shapeRendering: "crispEdges"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_2448",
    x: 4.74995,
    y: 6.75441,
    width: 11,
    height: 15,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_2448"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_2448",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.796616 0.224457)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeat);
export default __webpack_public_path__ + "static/media/repeat.9fcce4778f50e10c73bdde8af9a386be.svg";
export { ForwardRef as ReactComponent };